const columnDataHub = [
  {
    dataField: 'statusOfStock',
    caption: 'Статус запаса',
    dataType: 'string'
  }
];
export default columnDataHub;
